"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MOST_COMMON_ITEM_MAX_AMOUNT_LINES = exports.MAX_QUERY_LENGTH = exports.MAX_AMOUNT_ITEMS_TO_RENDER = void 0;
const MAX_AMOUNT_ITEMS_TO_RENDER = exports.MAX_AMOUNT_ITEMS_TO_RENDER = 15;
const MAX_QUERY_LENGTH = exports.MAX_QUERY_LENGTH = 60;
const MOST_COMMON_ITEM_MAX_AMOUNT_LINES = exports.MOST_COMMON_ITEM_MAX_AMOUNT_LINES = 2;
